import { closeChat } from '../chat/actions.any';
import { PARTICIPANTS_PANE_OPEN } from './actionTypes';
import { setCloseDialog as closeModerationPane } from '../moderator-controller/slice';
export * from './actions.any';
/**
 * Action to open the participants pane.
 *
 * @returns {Object}
 */
export function open() {
    return function (dispatch) {
        dispatch(closeChat());
        dispatch(closeModerationPane());
        dispatch({
            type: PARTICIPANTS_PANE_OPEN
        });
    };
}
